__turbopack_context__.v({
  "actions": "OrderEntryWidget-module__RQxGvG__actions",
  "advancedPanel": "OrderEntryWidget-module__RQxGvG__advancedPanel",
  "advancedToggle": "OrderEntryWidget-module__RQxGvG__advancedToggle",
  "blockReason": "OrderEntryWidget-module__RQxGvG__blockReason",
  "confirmActions": "OrderEntryWidget-module__RQxGvG__confirmActions",
  "confirmBox": "OrderEntryWidget-module__RQxGvG__confirmBox",
  "confirmCancel": "OrderEntryWidget-module__RQxGvG__confirmCancel",
  "confirmOk": "OrderEntryWidget-module__RQxGvG__confirmOk",
  "errorText": "OrderEntryWidget-module__RQxGvG__errorText",
  "field": "OrderEntryWidget-module__RQxGvG__field",
  "fieldFull": "OrderEntryWidget-module__RQxGvG__fieldFull",
  "fieldGrid": "OrderEntryWidget-module__RQxGvG__fieldGrid",
  "helper": "OrderEntryWidget-module__RQxGvG__helper",
  "input": "OrderEntryWidget-module__RQxGvG__input",
  "inputError": "OrderEntryWidget-module__RQxGvG__inputError",
  "inputRight": "OrderEntryWidget-module__RQxGvG__inputRight",
  "label": "OrderEntryWidget-module__RQxGvG__label",
  "markMuted": "OrderEntryWidget-module__RQxGvG__markMuted",
  "markReadout": "OrderEntryWidget-module__RQxGvG__markReadout",
  "marketStrip": "OrderEntryWidget-module__RQxGvG__marketStrip",
  "offlineBanner": "OrderEntryWidget-module__RQxGvG__offlineBanner",
  "quickBtn": "OrderEntryWidget-module__RQxGvG__quickBtn",
  "quickRow": "OrderEntryWidget-module__RQxGvG__quickRow",
  "riskBad": "OrderEntryWidget-module__RQxGvG__riskBad",
  "riskGrid": "OrderEntryWidget-module__RQxGvG__riskGrid",
  "riskKey": "OrderEntryWidget-module__RQxGvG__riskKey",
  "riskRow": "OrderEntryWidget-module__RQxGvG__riskRow",
  "riskVal": "OrderEntryWidget-module__RQxGvG__riskVal",
  "riskWarn": "OrderEntryWidget-module__RQxGvG__riskWarn",
  "select": "OrderEntryWidget-module__RQxGvG__select",
  "sideBtn": "OrderEntryWidget-module__RQxGvG__sideBtn",
  "sideBuy": "OrderEntryWidget-module__RQxGvG__sideBuy",
  "sideBuyActive": "OrderEntryWidget-module__RQxGvG__sideBuyActive",
  "sideSell": "OrderEntryWidget-module__RQxGvG__sideSell",
  "sideSellActive": "OrderEntryWidget-module__RQxGvG__sideSellActive",
  "sideToggle": "OrderEntryWidget-module__RQxGvG__sideToggle",
  "submitBtn": "OrderEntryWidget-module__RQxGvG__submitBtn",
  "submitBuy": "OrderEntryWidget-module__RQxGvG__submitBuy",
  "submitSell": "OrderEntryWidget-module__RQxGvG__submitSell",
  "switchRow": "OrderEntryWidget-module__RQxGvG__switchRow",
  "symbolField": "OrderEntryWidget-module__RQxGvG__symbolField",
  "ticket": "OrderEntryWidget-module__RQxGvG__ticket",
  "warnText": "OrderEntryWidget-module__RQxGvG__warnText",
  "zone": "OrderEntryWidget-module__RQxGvG__zone",
  "zoneLabel": "OrderEntryWidget-module__RQxGvG__zoneLabel",
});
